import React, {useEffect, useState} from 'react';
import DocxViewer from '@components/common/DocxViewer/DocxViewer';
function VaccinationPackage1() {
    return (
        <DocxViewer fileUrl="https://betaweb.tnh.com.vn/bw_documents/goi-dich-vu-goi-kham-suc-khoe-tong-quat.docx" />
    );
}

export default VaccinationPackage1;
